import { render, staticRenderFns } from "./OrderExtraChargedNotifications.vue?vue&type=template&id=06e80c23"
import script from "./OrderExtraChargedNotifications.vue?vue&type=script&lang=js"
export * from "./OrderExtraChargedNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports